import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "config/authConfig"; // Adjusted the import path for clarity
import { HelmetProvider } from "react-helmet-async";
import App from "App";
import "./index.css";
import "./App.css";
import "./web.config";
import { store } from "reduxStore/store";
import { ConfigProvider } from "antd";
import { encryptData } from "components/encryptionHandler";
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    const resString = encryptData(response);
    sessionStorage.setItem("redirectInfo", resString)
  }).catch((error) => {
    console.log("redirect error", error);
  })
  // Set the first account as the active account if none is selected
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Enable account storage events (useful for multi-tab login scenarios)
  msalInstance.enableAccountStorageEvents();

  // Handle login success events
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });
});
// Create the root element for React
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <HelmetProvider>
        <ConfigProvider theme={{ token: { colorPrimary: "#64008f" } }}>
          <App />
        </ConfigProvider>
      </HelmetProvider>
    </MsalProvider>
  </Provider>
);